import lodash from 'lodash';

import { getLangText } from '../../../utils/langText';

export const getCorrectName = (obj, defaultLanguage?) => {
  if (obj.internalName) {
    // Modifications 2.0 - ModificationGroup
    return obj.internalName;
  }

  return getLangText(
    obj.nameLang ?? obj.titleLang ?? obj.name ?? obj.title ?? obj.group?.title,
    defaultLanguage,
  );
};

export const grouplist = (itemsToGroup, formId) => {
  if (formId == 'items' || formId == 'menuEntries' || formId == 'itemsUsedOn') {
    return lodash(itemsToGroup)
      .groupBy((item) => (item.categories ? item.categories[0]?.name : ''))
      .map((value, key) => ({ category: key, items: value }))
      .sort((a, b) => (a.category > b.category ? 1 : -1))
      .value();
  } else {
    const grouped = itemsToGroup.sort((a, b) => (a.category > b.category ? 1 : -1));
    return [{ items: grouped }];
  }
};

export const formatList = (t, formId, values, defaultLanguage) => {
  switch (formId) {
    case 'variations':
      return [
        {
          barTitle: t('General.Ingredients'),
          group: values.map((val) => ({
            id: val.id,
            title: val.name ?? val.title ?? '',
          })),
        },
      ];

    case 'upsales':
      return [
        {
          label: t('PIM.UpsellGroup'),
          group: values.map((val) => ({
            id: val.id,
            title: getLangText(val.name),
            items: val.items?.map((item) => ({
              id: item.id,
              title: item.title ?? item.name,
            })),
          })),
        },
      ];

    case 'alternateVariations':
      return [
        {
          label: t('PIM.IngredientGroup'),
          group: values.map((val) => ({
            id: val.id,
            title: getLangText(val.title ?? val.group?.title, defaultLanguage),
            items: (val.variations ?? val.group?.variations)?.map((item) => ({
              id: item.id,
              title: item.name,
            })),
          })),
        },
      ];

    case 'legacyVariations':
      return [
        {
          label: t('General.VariationGroup'),
          group: values.map((val) => ({
            id: val.id,
            title: getLangText(val.group?.title, defaultLanguage),
            items: val.group?.variations?.map((item) => ({
              id: item.id,
              title: item.name,
            })),
          })),
        },
      ];

    case 'items':
      return [
        {
          barTitle: t('PIM.UpsellGroupArticles'),
          group: values.map((val) => ({
            id: val.id,
            title: getLangText(val.titleLang ?? val.title),
            price: val.defaultPrice,
          })),
        },
      ];

    case 'menuEntries':
      return lodash(values)
        .groupBy((entry) => (entry.item.categories ? entry.item.categories[0]?.name : ''))
        .map((value, key) => ({ category: key, items: value }))
        .sort((a, b) => (a.category < b.category ? -1 : 1))
        .value()
        .map((group, i) => ({
          barTitle: group.category,
          group: group.items.map((entry) => ({
            id: entry.id ?? '',
            title: entry.item.title,
            price: entry.price,
            defaultPrice: entry.item.defaultPrice,
            instant: entry.instant,
          })),
        }));

    case 'modifications':
      return [
        {
          group: values.map((val) => ({
            id: val.id,
            title: val.internalName,
            items: val.variations?.map((item) => ({
              id: item.id,
              title: item.name,
            })),
          })),
        },
      ];

    default:
      return [
        {
          group: values.map((val) => ({
            id: val.id,
            title: getCorrectName(val, defaultLanguage),
            price: val.price ?? val.defaultPrice ?? null,
          })),
        },
      ];
  }
};
